import DialogBase from './DialogBase';
import './Dialog.scss';
import { withInjectedProps } from '../InjectedPropsContext';

/**
 * Wrapper for the dialog so that we can show/hide it easily.
 */

const Dialog = withInjectedProps(DialogBase);

export { Dialog };
export default Dialog;
